import axios from "@/utils/axios.js";

/**
 * 实名认证-证件类型
 */
export async function getCertData() {
  return axios.post("/certificatesConfigure/getData");
}

/**
 * 实名认证-提交
 * @param {object} params
 * agentName: 用户姓名,
 * idNumber: 用户id,
 * certType: 用户身份类型
 */
export async function postCertData(params) {
  return axios.post("/agentLogin/certificationNew", params);
}
